module.exports = __webpack_public_path__ + "static/media/kiwi-fruit.41182541.png";